import {MediaMatcher} from '@angular/cdk/layout';
import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {Router} from '@angular/router';
import {firstValueFrom, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {AventiObject} from 'src/app/models/AventiObject';
import {Checklist} from 'src/app/models/Checklist';
import {AventiFile} from 'src/app/models/File';
import {Objecttype} from 'src/app/models/Objecttype';
import {TreeNode} from 'primeng/api';
import {buildObjecttypeTree, findObjecttypeNode} from 'src/app/utils/objecttype-tree';
import {User} from 'src/app/models/User';
import {CurrentpathService} from 'src/app/services/currentpath.service';
import {DateService} from 'src/app/services/date.service';
import {IdService} from 'src/app/services/id.service';
import {ObjectService} from 'src/app/services/object.service';
import {PopupService} from 'src/app/services/popup.service';
import {SharedService} from 'src/app/services/shared.service';
import {SnackbarService} from 'src/app/services/snackbar.service';
import {environment} from 'src/environments/environment';
import {ConfirmComponent} from '../../common/bottom-sheet/confirm/confirm.component';
import {Project} from 'src/app/models/Project';
import {ChecklistService} from 'src/app/services/checklist.service';
import {ReceiptformService} from 'src/app/services/receiptform.service';
import {ProjectService} from 'src/app/services/project.service';

@Component({
  selector: 'app-object',
  templateUrl: './object.component.html',
  styleUrls: ['./object.component.css'],
  providers: [ObjectService],
})
export class ObjectComponent implements OnInit {
  @ViewChild('nameInput') nameInput!: ElementRef<HTMLInputElement>;
  @ViewChild('tfmTagInput') tfmTagInput!: ElementRef<HTMLInputElement>;
  @ViewChild('rdsTagInput') rdsTagInput!: ElementRef<HTMLInputElement>;
  @ViewChild('descInput') descInput!: ElementRef<HTMLInputElement>;
  @ViewChild('profileNumberInput') profileNumberInput!: ElementRef<HTMLInputElement>;
  @ViewChild('processInput') processInput!: ElementRef<HTMLInputElement>;
  @ViewChild('drawingInput') drawingInput!: ElementRef<HTMLInputElement>;
  @ViewChild('commentInput') commentInput!: ElementRef<HTMLInputElement>;
  Form = new UntypedFormGroup({
    name: new UntypedFormControl('', [Validators.required]),
  });
  FormTfmTag = new UntypedFormGroup({
    tfmTag: new UntypedFormControl('', []),
  });
  FormRdsTag = new UntypedFormGroup({
    rdsTag: new UntypedFormControl('', []),
  });
  FormDesc = new UntypedFormGroup({
    desc: new UntypedFormControl('', []),
  });
  FormProfilenumber = new UntypedFormGroup({
    profilenumber: new UntypedFormControl('', []),
  });
  FormProcess = new UntypedFormGroup({
    process: new UntypedFormControl('', []),
  });
  FormDrawing = new UntypedFormGroup({
    drawing: new UntypedFormControl('', []),
  });
  FormComment = new UntypedFormGroup({
    comment: new UntypedFormControl('', []),
  });
  FormTags = new UntypedFormGroup({
    key: new UntypedFormControl('', []),
    value: new UntypedFormControl('', []),
  });
  error: string;
  object: AventiObject;
  project: Project;
  projectid: string;
  isFieldScan = false;
  objectid: string;
  isLoading = true;
  isAdmin = false;
  objecttypes: Objecttype[];
  objecttypeTree: TreeNode[] = [];
  selectedTypeNode: TreeNode = null;
  editObjecttype = false;
  editname = false;
  editTfmTag = false;
  editRdsTag = false;
  editdesc = false;
  editprofilenumber = false;
  editprocess = false;
  editdrawing = false;
  editcomment = false;
  edittags: boolean[] = [];
  receiptforms: Checklist[] = [];
  receiptformsTemp: Checklist[];
  checklists: Checklist[] = [];
  checklistpdfs: AventiFile[];
  filesLoaded: boolean;
  checklistsSigned = false;
  files: AventiFile[];
  user: User;
  datetime: string;
  mobileQuery: MediaQueryList;
  private ngUnsubscribe = new Subject();

  constructor(
    private idservice: IdService,
    private objectservice: ObjectService,
    private receiptformservice: ReceiptformService,
    private projectservice: ProjectService,
    private bottomSheet: MatBottomSheet,
    private router: Router,
    media: MediaMatcher,
    private snackbarservice: SnackbarService,
    private dateservice: DateService,
    private sharedservice: SharedService,
    private popupservice: PopupService,
    private currentpathservice: CurrentpathService,
    private checklistservice: ChecklistService
  ) {
    this.mobileQuery = media.matchMedia(environment.mobileQueryMaxwidthSmall);
    sharedservice.user.pipe(takeUntil(this.ngUnsubscribe)).subscribe((user) => {
      if (user != null) {
        this.user = user;
        this.isAdmin = this.user.role?.name === 'admin';
      }
    });
    this.projectid = this.idservice.projectId();
    this.isFieldScan = this.idservice.isFieldScanPath();

    this.objectid = this.idservice.objectId();
    this.sharedservice.objecttypes
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((types) => {
        // Filter out Mottak category and deactivated types
        this.objecttypes = types.filter(
          type => type.category?.id !== 'loJgvvKxjzx1jk771Wuf' && type.active !== false
        );
        this.objecttypeTree = buildObjecttypeTree(this.objecttypes);
      });
  }

  get name() {
    return this.Form.get('name');
  }

  get tfmTag() {
    return this.FormTfmTag.get('tfmTag');
  }

  get rdsTag() {
    return this.FormRdsTag.get('rdsTag');
  }

  get desc() {
    return this.FormDesc.get('desc');
  }

  get profilenumber() {
    return this.FormProfilenumber.get('profilenumber');
  }

  get process() {
    return this.FormProcess.get('process');
  }

  get drawing() {
    return this.FormDrawing.get('drawing');
  }

  get comment() {
    return this.FormComment.get('comment');
  }

  get key() {
    return this.FormTags.get('key');
  }

  get value() {
    return this.FormTags.get('value');
  }

  async ngOnInit() {
    if (this.isFieldScan) {
      this.project = await firstValueFrom(this.projectservice.getFullProjectById(this.projectid));
      this.receiptformsTemp = [];
      this.checklistservice.getChecklistsForObject(this.projectid, this.objectid)
        .subscribe((checklists) => {
          if (checklists) {
            this.checklists = checklists ?? [];
            this.buildObject();
          }
        });
      this.checklistservice.getChecklistPDFsForObject(this.projectid, this.objectid)
        .subscribe((pdfs) => {
          if (pdfs) {
            this.checklistpdfs = pdfs ?? [];
            this.buildObject();
          }
        });
      const stateObject = history.state.object;
      if (stateObject) {
        this.object = stateObject;
        this.buildObject();
      } else {
        this.objectservice.getObjectById(this.projectid, this.objectid)
          .subscribe((object) => {
            if (object !== null) {
              this.object = object;
              this.buildObject();
            }
          });
      }
      this.receiptformservice.getReceiptformsForObject(this.objectid)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((receiptforms) => {
          if (receiptforms !== null && receiptforms.length > 0) {
            this.receiptformsTemp = receiptforms;
            this.buildObject();
          }
        });

      this.objectservice
        .getObjectFiles(this.objectid)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((files) => {
          if (files !== null) {
            this.files = files;
          }
        });
    } else {
      this.sharedservice.project
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((project) => {
          if (project !== null) {
            this.project = project;
          }
        });
      this.sharedservice.objects
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((objects) => {
          if (objects !== null) {
            objects.forEach((object) => {
              if (object.id === this.objectid) {
                this.object = object;
                this.buildObject();
              }
            });
          }
        });

      this.sharedservice.receiptforms
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((receiptforms) => {
          if (receiptforms !== null) {
            this.receiptformsTemp = receiptforms;
            this.buildObject();
          }
        });

      this.objectservice
        .getObjectFiles(this.objectid)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((files) => {
          if (files !== null) {
            this.files = files;
          }
        });
    }

    // this.sharedservice.checklists
    //   .pipe(takeUntil(this.ngUnsubscribe))
    //   .subscribe((checklists: Checklist[]) => {
    //     // if (checklists.length > 0) {
    //     this.checklistsTemp = checklists;
    //     this.buildObject();
    //     // }
    //   });

    // this.sharedservice.checklistpdfs
    //   .pipe(takeUntil(this.ngUnsubscribe))
    //   .subscribe((cpdfs) => {
    //     // if (cpdfs.length > 0) {
    //     this.checklistpdfs = cpdfs;
    //     this.buildObject();
    //     // }
    //   });
  }

  buildObject() {
    if ((this.isFieldScan && this.object && this.checklists && this.checklistpdfs) ||
      (!this.isFieldScan && this.object &&
        // this.checklistsTemp &&
        this.receiptformsTemp
        // this.checklistpdfs
      )
    ) {
      if (this.object.checklists?.length > 0) {
        this.object.checklists.forEach((cl) => {
          if (cl.status === 'signed') {
            this.checklistsSigned = true;
          }
        });
      } else {
        this.checklists.map(checklist => {
          checklist = this.sharedservice.prepareChecklistsChecklist(checklist, true);
          checklist = this.sharedservice.prepareChecklistsChecklistPdfs(checklist, this.checklistpdfs);
          return checklist;
        });
        this.object.checklists = this.checklists ?? [];
      }
      this.object.path =
        'projects/' + this.projectid + '/objects/' + this.object.id;

      if (this.object.tags?.length > 0 && this.edittags?.length === 0) {
        this.object.tags.forEach((_, index) => {
          this.edittags[index] = false;
        });
      }
      if (!this.object.lastupdated && this.object.editedBy) {
        this.object.lastupdated =
          this.object.editedBy[this.object.editedBy.length - 1].timestamp;
      }
      if (this.object.lastupdated) {
        this.datetime = this.dateservice.dateAsYYYYMMDDHHNNSS(
          this.object.lastupdated
        );
      }

      // if (this.object.files !== null) {
      //   this.filesLoaded = true;
      // }

      if (this.isFieldScan) {
        this.receiptformsTemp.forEach((receiptform) => {
          return this.sharedservice.prepareChecklistsChecklist(receiptform);
        });
        this.receiptforms = this.receiptformsTemp;
      } else {
        this.receiptforms = [];
        this.receiptformsTemp.forEach((receiptform) => {
          receiptform.objects.forEach((object) => {
            if (object.id === this.objectid) {
              this.receiptforms.push(receiptform);
            }
          });
        });
        this.receiptforms.forEach((receiptform) => {
          receiptform.objectsstring = '';
          receiptform.objects.forEach((object) => {
            receiptform.objectsstring +=
              object.type?.name + ' - ' + object.name + '\n';
          });
          receiptform.objectsstring = receiptform.objectsstring.slice(0, -2);
        });
      }
      this.isLoading = false;
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  toggleEditObjecttype() {
    this.editObjecttype = !this.editObjecttype;
    if (this.editObjecttype) {
      // Preselect the current type in the tree
      this.selectedTypeNode = this.object.type
        ? findObjecttypeNode(this.objecttypeTree, this.object.type.id)
        : null;
    }
  }

  async onSelectionChange(objecttype: Objecttype) {
    this.object.type = objecttype;
    await this.updateObject({type: this.object.type});
    this.editObjecttype = false;
  }

  async onSelectObjecttypeNode(node: TreeNode) {
    const selected = this.objecttypes.find(type => type.id === node?.data);
    if (!selected) {
      return;
    }
    await this.onSelectionChange({id: selected.id, name: selected.name});
  }

  async toggleArchived() {
    this.object.isarchived = !this.object.isarchived;
    await this.updateObject({isarchived: this.object.isarchived});
  }

  deleteObjectConfirm(): void {
    const sheet = this.bottomSheet.open(ConfirmComponent, {
      backdropClass: 'blur-dialog-backdrop',
      data: {
        title: 'Er du sikker?',
        text: 'Slette objekt: ' + this.object.name,
        yes: {
          name: 'Ja',
          icon: 'delete',
        },
        no: {
          name: 'Nei',
          icon: 'close',
        },
      },
    });
    sheet
      .afterDismissed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((confirm) => {
        if (confirm) {
          this.objectservice
            .deleteObject(this.object)
            .then(() => {
              console.log('Object deleted...');
              const redirectPath = this.isFieldScan ?
                '' : 'p/' + this.projectid + '/o';
              this.router.navigateByUrl(redirectPath).then(() => {
                this.snackbarservice.openSnackBar('Objekt slettet...', '');
              }).catch((err) => {
                console.error('Navigation error:', err);
              });
            })
            .catch((err) => {
              console.log(err);
              this.snackbarservice.openSnackBar(
                'Feil ved sletting av objekt',
                'Feil'
              );
            });
        }
      });
  }

  setFocusOnInput(inputElement: ElementRef<HTMLInputElement>, condition: boolean): void {
    if (condition && inputElement) {
      inputElement.nativeElement.focus();
    }
  }

  toggleEditName() {
    this.editname = !this.editname;
    this.Form.patchValue({
      name: this.object.name,
    });
    setTimeout(() => {
      this.setFocusOnInput(this.nameInput, this.editname);
    }, 0);
  }

  async saveName(name: string) {
    this.object.name = name;
    await this.updateObject({name});
    this.editname = false;
  }

  toggleEditTfmTag() {
    this.editTfmTag = !this.editTfmTag;
    this.FormTfmTag.patchValue({
      tfmTag: this.object.tfmTag,
    });
    setTimeout(() => {
      this.setFocusOnInput(this.tfmTagInput, this.editTfmTag);
    }, 0);
  }

  async saveTfmTag(tfmTag: string) {
    this.object.tfmTag = tfmTag;
    await this.updateObject({tfmTag});
    this.editTfmTag = false;
  }

  toggleEditRdsTag() {
    this.editRdsTag = !this.editRdsTag;
    this.FormRdsTag.patchValue({
      rdsTag: this.object.rdsTag,
    });
    setTimeout(() => {
      this.setFocusOnInput(this.rdsTagInput, this.editRdsTag);
    }, 0);
  }

  async saveRdsTag(rdsTag: string) {
    this.object.rdsTag = rdsTag;
    await this.updateObject({rdsTag});
    this.editRdsTag = false;
  }

  toggleEditDesc() {
    this.editdesc = !this.editdesc;
    this.FormDesc.patchValue({
      desc: this.object.desc,
    });
    setTimeout(() => {
      this.setFocusOnInput(this.descInput, this.editdesc);
    }, 0);
  }

  async saveDesc(desc: string) {
    this.object.desc = desc;
    await this.updateObject({desc});
    this.editdesc = false;
  }

  toggleEditProfilenumber() {
    this.editprofilenumber = !this.editprofilenumber;
    this.FormProfilenumber.patchValue({
      profilenumber: this.object.profilenumber,
    });
    setTimeout(() => {
      this.setFocusOnInput(this.profileNumberInput, this.editprofilenumber);
    }, 0);
  }

  async saveProfilenumber(profilenumber: string) {
    this.object.profilenumber = profilenumber;
    await this.updateObject({profilenumber});
    this.editprofilenumber = false;
  }

  toggleEditProcess() {
    this.editprocess = !this.editprocess;
    this.FormProcess.patchValue({
      process: this.object.process,
    });
    setTimeout(() => {
      this.setFocusOnInput(this.processInput, this.editprocess);
    }, 0);
  }

  async saveProcess(process: string) {
    this.object.process = process;
    await this.updateObject({process});
    this.editprocess = false;
  }

  toggleEditDrawing() {
    this.editdrawing = !this.editdrawing;
    this.FormDrawing.patchValue({
      drawing: this.object.drawing,
    });
    setTimeout(() => {
      this.setFocusOnInput(this.drawingInput, this.editdrawing);
    }, 0);
  }

  async saveDrawing(drawing: string) {
    this.object.drawing = drawing;
    await this.updateObject({drawing});
    this.editdrawing = false;
  }

  toggleEditComment() {
    this.editcomment = !this.editcomment;
    this.FormComment.patchValue({
      comment: this.object.comment,
    });
    setTimeout(() => {
      this.setFocusOnInput(this.commentInput, this.editcomment);
    }, 0);
  }

  async saveComment(comment: string) {
    this.object.comment = comment;
    await this.updateObject({comment});
    this.editcomment = false;
  }

  toggleEditTags(index: number) {
    if (!this.edittags[index]) {
      this.clearEditTags();
      this.edittags[index] = true;
    } else {
      this.clearEditTags();
    }
    if (this.edittags[index]) {
      this.FormTags.patchValue({
        key: this.object.tags[index].key,
        value: this.object.tags[index].value,
      });
    }
  }

  async saveTags(key: string, value: string, index: number) {
    if (key === '' && value === '') {
      this.object.tags.splice(index, 1);
    } else {
      this.object.tags[index] = {key, value};
    }
    await this.updateObject({tags: this.object.tags});
    this.edittags[index] = false;
  }

  async newTag() {
    const tags = this.object.tags ?? [];
    const newindex = tags.length;
    tags.push({key: '', value: ''});
    await this.updateObject({tags});
    this.object.tags = tags;
    this.clearEditTags();
    this.edittags[newindex] = true;
    this.FormTags.patchValue({
      key: this.object.tags[newindex].key,
      value: this.object.tags[newindex].value,
    });
  }

  clearEditTags() {
    this.edittags.forEach((_, i, arr) => {
      arr[i] = false;
    });
  }

  async updateObject(object: Partial<AventiObject>) {
    if (object.checklists) {
      object.checklists.pop();
    }
    await this.objectservice.updatePartialObject(this.objectid, object);
  }

  // True when the object has no completed status level but a checklist that is under way.
  objectChecklistStarted(object: AventiObject): boolean {
    return !!object.checklists?.some(cl => cl.status && cl.status !== 'not_started');
  }

  newReceiptformClick() {
    this.popupservice.openDialogNewReceiptForm(this.user, this.projectid, this.object);
  }

  copyFileLocation() {
    this.currentpathservice.copyFilePathToClipboard();
  }
}
